import React from "react";
import DateWrapper from "./date-wrapper";
import FestivalDay from "@default/general-components/date-time/festival-day";
import validAppearancesFilter from "@default/lib/valid-appearances-filter";

const FeaturedEvents = ({ content }) => {
  if (
    // Edge case: unpublished appearances return null, but array is not empty.
    (content.fieldAppearances?.length &&
      content.fieldAppearances.filter(Boolean).length === 0) ||
    // Appearances are empty
    (content.fieldAppearances && content.fieldAppearances.length === 0) ||
    // Appearances are not set
    !content.fieldAppearances
  ) {
    return (
      <div className={"featured-event-wrapper"}>
        <div className="title make-headline-light">TBA</div>
      </div>
    );
  }

  return (
    <div className={"featured-event-wrapper"}>
      {validAppearancesFilter(content.fieldAppearances).map(
        (featuredEvent, index) => (
          <div className="featured-on-event" key={index}>
            {featuredEvent.fieldHappening?.label && (
              <div className="title make-headline-light">
                {featuredEvent.fieldHappening.label}
              </div>
            )}
            <DateWrapper content={featuredEvent} showEndDate={true} />
            <FestivalDay appearance={featuredEvent} />
          </div>
        )
      )}
    </div>
  );
};

export default FeaturedEvents;
